import { useUser } from '@liveblocks/react'

import { COMMENT_LABELS } from './labels'

type UserNameProps = {
  userId: string
}

export const UserName = ({ userId }: UserNameProps) => {
  const { user, isLoading } = useUser(userId)
  if (user?.name) return <>{user.name}</>
  return <>{isLoading ? '' : COMMENT_LABELS.unknownAuthor}</>
}
